/**
 * Factory function for initializing the MSAL instances during app startup
 */
import { MsalInitializerService } from './_shared/services/authentication/msal-initializer.service';
import { RuntimeConfigService } from './_shared/services/config/runtime-config.service';

export function initializeMsalInstances(
  msalInitializer: MsalInitializerService,
  runtimeConfigService: RuntimeConfigService
): () => Promise<void> {
  return async () => {
    try {
      console.log('[App Initialization] Starting MSAL instances initialization');

      // The actual MSAL initialization will happen in the login services
      console.log('[App Initialization] Runtime config loaded, MSAL instances will initialize on first use');

    } catch (error) {
      console.error('[App Initialization] Error during MSAL initialization:', error);
    }
  };
}
